import { Form } from "antd";
import { FormInstance } from "antd-v5";
import message from "components/CustomMessage";
import { isUndefined } from "lodash";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes } from "utils/formUtils";

import GenericMappingForm from "../GenericMappingForm";

interface Props {
  record?: {
    repositoryId: string;
    repositoryName: string;
  };
  toolName: string;
  loginConfigId: string;
}

interface Project {
  id: string;
  name: string;
}

const initialFormValues = {
  product: undefined,
  subProduct: undefined,
  environment: undefined,
};

const SocketDevMappingForm = forwardRef<FormInstance, Props>((props, ref) => {
  const [projects, setProjects] = useState<Project[]>(() => {
    if (props.record) {
      const { repositoryId, repositoryName } = props.record;
      const repositoryIdArray = repositoryId.split(",");
      const repositoryNameArray = repositoryName.split(",");

      return repositoryIdArray.map((id, index) => ({
        id,
        name: repositoryNameArray[index] || "Unknown",
      }));
    }
    return [];
  });

  const [initialValues] = useState(() => {
    if (props.record) {
      return [];
    }
    return [{ ...initialFormValues }];
  });

  const [form] = Form.useForm();

  useEffect(() => {
    const { promise, cancel } =
      ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
        login_id: props.loginConfigId,
      });

    promise
      .then((response) => {
        setProjects(response.projects || []);
      })
      .catch(() => {
        message.error("Problem fetching organization");
      });

    return cancel;
  }, [props.loginConfigId, props.toolName]);

  const parseExtraFieldsDataFromResponse = useCallback((config: any) => {
    const { repositoryId, repositoryName } = config;
    return {
      repositoryId: repositoryId.split(","),
      repositoryName: repositoryName.split(","),
      ...(config.discovery_config_id && {
        discovery_config_id: config.discovery_config_id,
      }),
    };
  }, []);

  const getExtraFieldsData = (config: any) => {
    const { repositoryId } = config;
    const selectedProject = projects
      .filter((project: Project) => repositoryId.includes(project.id))
      .map((project: Project) => project.name);

    return {
      repositoryId: repositoryId.join(),
      repositoryName: selectedProject.join(),
      ...(config.discovery_config_id && {
        discovery_config_id: config.discovery_config_id,
      }),
    };
  };

  const extraFields = useMemo(
    () => [
      {
        name: "repositoryId",
        colSpan: "12",
        type: FieldTypes.MULTI_SELECT,
        label: "Repository",
        options: projects,
        required: true,
        loading: isUndefined(projects),
      },
    ],
    [projects],
  );

  return (
    <GenericMappingForm
      {...props}
      //@ts-expect-error
      form={form}
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      formDefaultValues={initialValues}
    />
  );
});

export default SocketDevMappingForm;
